import type { DiscoverCollection } from '../../schema-copy/api-schema';

/** Highest priority first, collections without a priority last; ties keep their current order. */
export const sortCollectionsByPriority = (collections: DiscoverCollection[]): DiscoverCollection[] =>
  [...collections].sort((a, b) => (b.priority ?? -Infinity) - (a.priority ?? -Infinity));
